import { Col, Row } from "react-bootstrap";
import SingleMerchandiseCard from "./SingleMerchandiseCard";
import { Product } from "../../services/productService";
import { Pack, getPackDisplayImage } from "../../services/packService";
import PackOne from "../../assets/img/new-theme/pack-1.png";

type Props = {
    selectedItems: { [key: number]: number };
    selectedMerchandiseCount: { [key: number]: number };
    onSelect: (index: number, product?: Product) => void;
    onAddmore: (item: any, index?: number) => void;
    onIncrease: (index: number) => void;
    onDecrease: (index: number) => void;
    products?: Product[];
    packs?: Pack[];
    packSelectedItems?: { [key: number]: number };
    packSelectedCount?: { [key: number]: number };
    onPackSelect?: (index: number, pack: Pack) => void;
    favouriteImg?: any;
    variant?: "default" | "packs";
};

const MerchandiseSelectionList = ({
    selectedItems,
    selectedMerchandiseCount,
    onSelect,
    onAddmore,
    onIncrease,
    onDecrease,
    products,
    packs,
    packSelectedItems,
    packSelectedCount,
    onPackSelect,
    favouriteImg,
    variant = "default",
}: Props) => {
    const itemsToDisplay =
        products && products?.length > 0 ? products : [];
    const packItems = packs && packs.length > 0 ? packs : [];

    return (
        <>
            <div className="frameCard packSelectionGrid">
                <Col xl={12} className="mx-auto">
                    <Row className="g-4">
                        {variant === "packs" &&
                            packItems.map((pack, index) => (
                                <SingleMerchandiseCard
                                    key={pack.id ?? `pack-${index}`}
                                    item={pack}
                                    selected={!!packSelectedItems?.[index]}
                                    count={packSelectedCount?.[index] ?? 0}
                                    favouriteImg={favouriteImg}
                                    variant="packs"
                                    packImageOverride={getPackDisplayImage(pack, PackOne)}
                                    onSelect={() => onPackSelect?.(index, pack)}
                                />
                            ))}

                        {itemsToDisplay.map((item: any, index) => {
                            const key = item?.id?.toString() || item?.sku_code || `item-${index}`;
                            const newItem = {
                                ...item,
                                finalCanvasImage: favouriteImg,
                            };

                            return (
                                <SingleMerchandiseCard
                                    key={key}
                                    item={newItem}
                                    selected={!!selectedItems[index]}
                                    count={selectedMerchandiseCount[index] ?? 1}
                                    onSelect={() => onSelect(index, newItem)}
                                    onAddToCart={() => onAddmore(newItem, index)}
                                    onIncrease={() => onIncrease(index)}
                                    onDecrease={() => onDecrease(index)}
                                    favouriteImg={favouriteImg}
                                    variant={variant}
                                />
                            );
                        })}
                    </Row>
                </Col>

            </div>
        </>
    );
};


export default MerchandiseSelectionList;
